// Generated by purs version 0.15.4
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Lazy from "../Control.Lazy/index.js";
import * as Control_Monad_Reader_Class from "../Control.Monad.Reader.Class/index.js";
import * as Control_Monad_Reader_Trans from "../Control.Monad.Reader.Trans/index.js";
import * as Control_Monad_Rec_Class from "../Control.Monad.Rec.Class/index.js";
import * as Control_Monad_State from "../Control.Monad.State/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Control_Monad_State_Trans from "../Control.Monad.State.Trans/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Date from "../Data.Date/index.js";
import * as Data_Date_Component from "../Data.Date.Component/index.js";
import * as Data_DateTime from "../Data.DateTime/index.js";
import * as Data_DateTime_Instant from "../Data.DateTime.Instant/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Enum from "../Data.Enum/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Formatter_Internal from "../Data.Formatter.Internal/index.js";
import * as Data_Formatter_Parser_Number from "../Data.Formatter.Parser.Number/index.js";
import * as Data_Formatter_Parser_Utils from "../Data.Formatter.Parser.Utils/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Ring from "../Data.Ring/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_CodePoints from "../Data.String.CodePoints/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data_Time from "../Data.Time/index.js";
import * as Data_Time_Component from "../Data.Time.Component/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Parsing from "../Parsing/index.js";
import * as Parsing_Combinators from "../Parsing.Combinators/index.js";
import * as Parsing_String from "../Parsing.String/index.js";
import * as Parsing_String_Basic from "../Parsing.String.Basic/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Reader_Trans.bindReaderT(Data_Either.bindEither));
var ask = /* #__PURE__ */ Control_Monad_Reader_Class.ask(/* #__PURE__ */ Control_Monad_Reader_Trans.monadAskReaderT(Data_Either.monadEither));
var lift = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(Data_Either.monadEither);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var for_ = /* #__PURE__ */ Data_Foldable.for_(Data_Either.applicativeEither)(Data_Foldable.foldableArray);
var when = /* #__PURE__ */ Control_Applicative.when(Data_Either.applicativeEither);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var foldMap = /* #__PURE__ */ Data_Foldable.foldMap(Data_List_Types.foldableList);
var foldMap1 = /* #__PURE__ */ foldMap(Data_Monoid.monoidString);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Parsing.functorParserT);
var oneOfAs = /* #__PURE__ */ Data_Formatter_Parser_Utils.oneOfAs(Data_Functor.functorArray)(Data_Foldable.foldableArray);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Parsing.bindParserT);
var foldDigits = /* #__PURE__ */ Data_Formatter_Internal.foldDigits(Data_List_Types.foldableList);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Parsing.applicativeParserT);
var map = /* #__PURE__ */ Data_Functor.map(Parsing.functorParserT);
var negate = /* #__PURE__ */ Data_Ring.negate(Data_Ring.ringInt);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var abs = /* #__PURE__ */ Data_Ord.abs(Data_Ord.ordInt)(Data_Ring.ringInt);
var some = /* #__PURE__ */ Data_List.some(Parsing.alternativeParserT)(Parsing.lazyParserT);
var fromEnum = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumYear);
var show1 = /* #__PURE__ */ Data_Show.show(Data_Date_Component.showMonth);
var fromEnum1 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumMonth);
var fromEnum2 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumDay);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var fromEnum3 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumWeekday);
var show2 = /* #__PURE__ */ Data_Show.show(Data_Date_Component.showWeekday);
var fromEnum4 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumHour);
var mod = /* #__PURE__ */ Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt);
var fromEnum5 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumMinute);
var fromEnum6 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumSecond);
var fromEnum7 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumMillisecond);
var div1 = /* #__PURE__ */ Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt);
var mapFlipped1 = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Either.functorEither);
var monadStateT = /* #__PURE__ */ Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity);
var lift1 = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Parsing.monadTransParserT)(monadStateT);
var monadStateStateT = /* #__PURE__ */ Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity);
var modify_ = /* #__PURE__ */ Control_Monad_State_Class.modify_(monadStateStateT);
var lift2 = /* #__PURE__ */ Control_Apply.lift2(Parsing.applyParserT);
var mul = /* #__PURE__ */ Data_Semiring.mul(Data_Semiring.semiringInt);
var parseDigit = /* #__PURE__ */ Data_Formatter_Parser_Number.parseDigit(monadStateT);
var append1 = /* #__PURE__ */ Data_Semigroup.append(/* #__PURE__ */ Control_Monad_Reader_Trans.semigroupReaderT(Data_Either.applyEither)(Data_Semigroup.semigroupUnit));
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var put = /* #__PURE__ */ Control_Monad_State_Class.put(monadStateStateT);
var $$void = /* #__PURE__ */ Data_Functor["void"](Parsing.functorParserT);
var compare = /* #__PURE__ */ Data_Ord.compare(Data_Ord.ordString);
var applySecond = /* #__PURE__ */ Control_Apply.applySecond(Data_Either.applyEither);
var apply = /* #__PURE__ */ Control_Apply.apply(Data_Either.applyEither);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var toEnum = /* #__PURE__ */ Data_Enum.toEnum(Data_Date_Component.boundedEnumYear);
var toEnum1 = /* #__PURE__ */ Data_Enum.toEnum(Data_Date_Component.boundedEnumMonth);
var toEnum2 = /* #__PURE__ */ Data_Enum.toEnum(Data_Date_Component.boundedEnumDay);
var toEnum3 = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumHour);
var toEnum4 = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumMinute);
var toEnum5 = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumSecond);
var toEnum6 = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumMillisecond);
var voidLeft = /* #__PURE__ */ Data_Functor.voidLeft(Data_Either.functorEither);
var mapParserT = /* #__PURE__ */ Parsing.mapParserT(/* #__PURE__ */ Control_Monad_State_Trans.monadRecStateT(Control_Monad_Rec_Class.monadRecIdentity));
var foldMap2 = /* #__PURE__ */ foldMap(/* #__PURE__ */ Parsing.monoidParserT(Data_Monoid.monoidUnit));
var bind2 = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var AM = /* #__PURE__ */ (function () {
    function AM() {

    };
    AM.value = new AM();
    return AM;
})();
var PM = /* #__PURE__ */ (function () {
    function PM() {

    };
    PM.value = new PM();
    return PM;
})();
var YearFull = /* #__PURE__ */ (function () {
    function YearFull() {

    };
    YearFull.value = new YearFull();
    return YearFull;
})();
var YearTwoDigits = /* #__PURE__ */ (function () {
    function YearTwoDigits() {

    };
    YearTwoDigits.value = new YearTwoDigits();
    return YearTwoDigits;
})();
var YearAbsolute = /* #__PURE__ */ (function () {
    function YearAbsolute() {

    };
    YearAbsolute.value = new YearAbsolute();
    return YearAbsolute;
})();
var MonthFull = /* #__PURE__ */ (function () {
    function MonthFull() {

    };
    MonthFull.value = new MonthFull();
    return MonthFull;
})();
var MonthShort = /* #__PURE__ */ (function () {
    function MonthShort() {

    };
    MonthShort.value = new MonthShort();
    return MonthShort;
})();
var MonthTwoDigits = /* #__PURE__ */ (function () {
    function MonthTwoDigits() {

    };
    MonthTwoDigits.value = new MonthTwoDigits();
    return MonthTwoDigits;
})();
var DayOfMonthTwoDigits = /* #__PURE__ */ (function () {
    function DayOfMonthTwoDigits() {

    };
    DayOfMonthTwoDigits.value = new DayOfMonthTwoDigits();
    return DayOfMonthTwoDigits;
})();
var DayOfMonth = /* #__PURE__ */ (function () {
    function DayOfMonth() {

    };
    DayOfMonth.value = new DayOfMonth();
    return DayOfMonth;
})();
var UnixTimestamp = /* #__PURE__ */ (function () {
    function UnixTimestamp() {

    };
    UnixTimestamp.value = new UnixTimestamp();
    return UnixTimestamp;
})();
var DayOfWeek = /* #__PURE__ */ (function () {
    function DayOfWeek() {

    };
    DayOfWeek.value = new DayOfWeek();
    return DayOfWeek;
})();
var DayOfWeekName = /* #__PURE__ */ (function () {
    function DayOfWeekName() {

    };
    DayOfWeekName.value = new DayOfWeekName();
    return DayOfWeekName;
})();
var DayOfWeekNameShort = /* #__PURE__ */ (function () {
    function DayOfWeekNameShort() {

    };
    DayOfWeekNameShort.value = new DayOfWeekNameShort();
    return DayOfWeekNameShort;
})();
var Hours24 = /* #__PURE__ */ (function () {
    function Hours24() {

    };
    Hours24.value = new Hours24();
    return Hours24;
})();
var Hours12 = /* #__PURE__ */ (function () {
    function Hours12() {

    };
    Hours12.value = new Hours12();
    return Hours12;
})();
var Meridiem = /* #__PURE__ */ (function () {
    function Meridiem() {

    };
    Meridiem.value = new Meridiem();
    return Meridiem;
})();
var Minutes = /* #__PURE__ */ (function () {
    function Minutes() {

    };
    Minutes.value = new Minutes();
    return Minutes;
})();
var MinutesTwoDigits = /* #__PURE__ */ (function () {
    function MinutesTwoDigits() {

    };
    MinutesTwoDigits.value = new MinutesTwoDigits();
    return MinutesTwoDigits;
})();
var Seconds = /* #__PURE__ */ (function () {
    function Seconds() {

    };
    Seconds.value = new Seconds();
    return Seconds;
})();
var SecondsTwoDigits = /* #__PURE__ */ (function () {
    function SecondsTwoDigits() {

    };
    SecondsTwoDigits.value = new SecondsTwoDigits();
    return SecondsTwoDigits;
})();
var Milliseconds = /* #__PURE__ */ (function () {
    function Milliseconds() {

    };
    Milliseconds.value = new Milliseconds();
    return Milliseconds;
})();
var MillisecondsShort = /* #__PURE__ */ (function () {
    function MillisecondsShort() {

    };
    MillisecondsShort.value = new MillisecondsShort();
    return MillisecondsShort;
})();
var MillisecondsTwoDigits = /* #__PURE__ */ (function () {
    function MillisecondsTwoDigits() {

    };
    MillisecondsTwoDigits.value = new MillisecondsTwoDigits();
    return MillisecondsTwoDigits;
})();
var Placeholder = /* #__PURE__ */ (function () {
    function Placeholder(value0) {
        this.value0 = value0;
    };
    Placeholder.create = function (value0) {
        return new Placeholder(value0);
    };
    return Placeholder;
})();
var validateRange = function (min) {
    return function (max) {
        return bind(ask)(function (v) {
            return lift((function () {
                var $315 = v.num < min || v.num > max;
                if ($315) {
                    return new Data_Either.Left("Number is out of range [ " + (show(min) + (", " + (show(max) + " ]"))));
                };
                return new Data_Either.Right(Data_Unit.unit);
            })());
        });
    };
};
var validAccum = function (v) {
    if (v.hour instanceof Data_Maybe.Just && v.hour.value0 === 24) {
        return for_([ v.minute, v.second, v.millisecond ])(function (val) {
            return when(Data_Maybe.fromMaybe(0)(val) > 0)(new Data_Either.Left("When hour is 24, other time components must be 0"));
        });
    };
    return pure(Data_Unit.unit);
};
var takeSome = function (dictAlternative) {
    var Applicative0 = dictAlternative.Applicative0();
    var pure2 = Control_Applicative.pure(Applicative0);
    var apply1 = Control_Apply.apply(Applicative0.Apply0());
    var map3 = Data_Functor.map(((dictAlternative.Plus1()).Alt0()).Functor0());
    return function (dictLazy) {
        var defer = Control_Lazy.defer(dictLazy);
        return function (v) {
            return function (v1) {
                if (v === 0) {
                    return pure2(Data_List_Types.Nil.value);
                };
                return apply1(map3(Data_List_Types.Cons.create)(v1))(defer(function (v3) {
                    return takeMany(dictAlternative)(dictLazy)(v - 1 | 0)(v1);
                }));
            };
        };
    };
};
var takeMany = function (dictAlternative) {
    var pure2 = Control_Applicative.pure(dictAlternative.Applicative0());
    var alt = Control_Alt.alt((dictAlternative.Plus1()).Alt0());
    return function (dictLazy) {
        return function (v) {
            return function (v1) {
                if (v === 0) {
                    return pure2(Data_List_Types.Nil.value);
                };
                return alt(takeSome(dictAlternative)(dictLazy)(v)(v1))(pure2(Data_List_Types.Nil.value));
            };
        };
    };
};
var takeSome1 = /* #__PURE__ */ takeSome(Parsing.alternativeParserT)(Parsing.lazyParserT);
var printShortMonth = function (v) {
    if (v instanceof Data_Date_Component.January) {
        return "Jan";
    };
    if (v instanceof Data_Date_Component.February) {
        return "Feb";
    };
    if (v instanceof Data_Date_Component.March) {
        return "Mar";
    };
    if (v instanceof Data_Date_Component.April) {
        return "Apr";
    };
    if (v instanceof Data_Date_Component.May) {
        return "May";
    };
    if (v instanceof Data_Date_Component.June) {
        return "Jun";
    };
    if (v instanceof Data_Date_Component.July) {
        return "Jul";
    };
    if (v instanceof Data_Date_Component.August) {
        return "Aug";
    };
    if (v instanceof Data_Date_Component.September) {
        return "Sep";
    };
    if (v instanceof Data_Date_Component.October) {
        return "Oct";
    };
    if (v instanceof Data_Date_Component.November) {
        return "Nov";
    };
    if (v instanceof Data_Date_Component.December) {
        return "Dec";
    };
    throw new Error("Failed pattern match at Data.Formatter.DateTime (line 489, column 19 - line 501, column 22): " + [ v.constructor.name ]);
};
var printFormatterCommand = function (v) {
    if (v instanceof YearFull) {
        return "YYYY";
    };
    if (v instanceof YearTwoDigits) {
        return "YY";
    };
    if (v instanceof YearAbsolute) {
        return "Y";
    };
    if (v instanceof MonthFull) {
        return "MMMM";
    };
    if (v instanceof MonthShort) {
        return "MMM";
    };
    if (v instanceof MonthTwoDigits) {
        return "MM";
    };
    if (v instanceof DayOfMonthTwoDigits) {
        return "DD";
    };
    if (v instanceof DayOfMonth) {
        return "D";
    };
    if (v instanceof UnixTimestamp) {
        return "X";
    };
    if (v instanceof DayOfWeek) {
        return "E";
    };
    if (v instanceof DayOfWeekName) {
        return "dddd";
    };
    if (v instanceof DayOfWeekNameShort) {
        return "ddd";
    };
    if (v instanceof Hours24) {
        return "HH";
    };
    if (v instanceof Hours12) {
        return "hh";
    };
    if (v instanceof Meridiem) {
        return "a";
    };
    if (v instanceof Minutes) {
        return "m";
    };
    if (v instanceof MinutesTwoDigits) {
        return "mm";
    };
    if (v instanceof Seconds) {
        return "s";
    };
    if (v instanceof SecondsTwoDigits) {
        return "ss";
    };
    if (v instanceof MillisecondsShort) {
        return "S";
    };
    if (v instanceof MillisecondsTwoDigits) {
        return "SS";
    };
    if (v instanceof Milliseconds) {
        return "SSS";
    };
    if (v instanceof Placeholder) {
        return v.value0;
    };
    throw new Error("Failed pattern match at Data.Formatter.DateTime (line 85, column 25 - line 108, column 21): " + [ v.constructor.name ]);
};
var printFormatter = /* #__PURE__ */ foldMap1(printFormatterCommand);
var placeholderContent = /* #__PURE__ */ mapFlipped(/* #__PURE__ */ Data_Array.some(Parsing.alternativeParserT)(Parsing.lazyParserT)(/* #__PURE__ */ Parsing_String_Basic.noneOf(/* #__PURE__ */ Data_String_CodeUnits.toCharArray("YMDEHhamsS"))))(Data_String_CodeUnits.fromCharArray);
var parseShortMonth = function (dictMonad) {
    return oneOfAs(dictMonad)(function ($658) {
        return Parsing_Combinators["try"](Parsing_String.string($658));
    })([ new Data_Tuple.Tuple("Jan", Data_Date_Component.January.value), new Data_Tuple.Tuple("Feb", Data_Date_Component.February.value), new Data_Tuple.Tuple("Mar", Data_Date_Component.March.value), new Data_Tuple.Tuple("Apr", Data_Date_Component.April.value), new Data_Tuple.Tuple("May", Data_Date_Component.May.value), new Data_Tuple.Tuple("Jun", Data_Date_Component.June.value), new Data_Tuple.Tuple("Jul", Data_Date_Component.July.value), new Data_Tuple.Tuple("Aug", Data_Date_Component.August.value), new Data_Tuple.Tuple("Sep", Data_Date_Component.September.value), new Data_Tuple.Tuple("Oct", Data_Date_Component.October.value), new Data_Tuple.Tuple("Nov", Data_Date_Component.November.value), new Data_Tuple.Tuple("Dec", Data_Date_Component.December.value) ]);
};
var parseShortMonth1 = /* #__PURE__ */ parseShortMonth(monadStateT);
var parseMonth = function (dictMonad) {
    return oneOfAs(dictMonad)(function ($659) {
        return Parsing_Combinators["try"](Parsing_String.string($659));
    })([ new Data_Tuple.Tuple("January", Data_Date_Component.January.value), new Data_Tuple.Tuple("February", Data_Date_Component.February.value), new Data_Tuple.Tuple("March", Data_Date_Component.March.value), new Data_Tuple.Tuple("April", Data_Date_Component.April.value), new Data_Tuple.Tuple("May", Data_Date_Component.May.value), new Data_Tuple.Tuple("June", Data_Date_Component.June.value), new Data_Tuple.Tuple("July", Data_Date_Component.July.value), new Data_Tuple.Tuple("August", Data_Date_Component.August.value), new Data_Tuple.Tuple("September", Data_Date_Component.September.value), new Data_Tuple.Tuple("October", Data_Date_Component.October.value), new Data_Tuple.Tuple("November", Data_Date_Component.November.value), new Data_Tuple.Tuple("December", Data_Date_Component.December.value) ]);
};
var parseMonth1 = /* #__PURE__ */ parseMonth(monadStateT);
var parseMeridiem = function (dictMonad) {
    return oneOfAs(dictMonad)(function ($660) {
        return Parsing_Combinators["try"](Parsing_String.string($660));
    })([ new Data_Tuple.Tuple("am", AM.value), new Data_Tuple.Tuple("AM", AM.value), new Data_Tuple.Tuple("pm", PM.value), new Data_Tuple.Tuple("PM", PM.value) ]);
};
var parseMeridiem1 = /* #__PURE__ */ parseMeridiem(monadStateT);
var $$parseInt = function (dictMonad) {
    var parseDigit1 = Data_Formatter_Parser_Number.parseDigit(dictMonad);
    return function (maxLength) {
        return function (validators) {
            return function (errMsg) {
                return bind1(takeSome1(maxLength)(parseDigit1))(function (ds) {
                    var num = foldDigits(ds);
                    var length = Data_List.length(ds);
                    var v = Control_Monad_Reader_Trans.runReaderT(validators)({
                        length: length,
                        num: num,
                        maxLength: maxLength
                    });
                    if (v instanceof Data_Either.Left) {
                        return Parsing.fail(errMsg + ("(" + (v.value0 + ")")));
                    };
                    if (v instanceof Data_Either.Right) {
                        return pure1(num);
                    };
                    throw new Error("Failed pattern match at Data.Formatter.DateTime (line 342, column 3 - line 344, column 24): " + [ v.constructor.name ]);
                });
            };
        };
    };
};
var parseInt1 = /* #__PURE__ */ $$parseInt(monadStateT);
var parseSignedInt = function (dictMonad) {
    var parseInt2 = $$parseInt(dictMonad);
    return function (maxLength) {
        return function (validators) {
            return function (errMsg) {
                return bind1(map(Data_Maybe.isJust)(Parsing_Combinators.optionMaybe(Parsing_String["char"]("-"))))(function (isNegative) {
                    return map((function () {
                        if (isNegative) {
                            return negate;
                        };
                        return identity;
                    })())(parseInt2(maxLength)(validators)(errMsg));
                });
            };
        };
    };
};
var parseSignedInt1 = /* #__PURE__ */ parseSignedInt(monadStateT);
var parseDayOfWeekNameShort = function (dictMonad) {
    return oneOfAs(dictMonad)(function ($661) {
        return Parsing_Combinators["try"](Parsing_String.string($661));
    })([ new Data_Tuple.Tuple("Mon", Data_Date_Component.Monday.value), new Data_Tuple.Tuple("Tue", Data_Date_Component.Tuesday.value), new Data_Tuple.Tuple("Wed", Data_Date_Component.Wednesday.value), new Data_Tuple.Tuple("Thu", Data_Date_Component.Thursday.value), new Data_Tuple.Tuple("Fri", Data_Date_Component.Friday.value), new Data_Tuple.Tuple("Sat", Data_Date_Component.Saturday.value), new Data_Tuple.Tuple("Sun", Data_Date_Component.Sunday.value) ]);
};
var parseDayOfWeekNameShort1 = /* #__PURE__ */ parseDayOfWeekNameShort(monadStateT);
var parseDayOfWeekName = function (dictMonad) {
    return oneOfAs(dictMonad)(function ($662) {
        return Parsing_Combinators["try"](Parsing_String.string($662));
    })([ new Data_Tuple.Tuple("Monday", Data_Date_Component.Monday.value), new Data_Tuple.Tuple("Tuesday", Data_Date_Component.Tuesday.value), new Data_Tuple.Tuple("Wednesday", Data_Date_Component.Wednesday.value), new Data_Tuple.Tuple("Thursday", Data_Date_Component.Thursday.value), new Data_Tuple.Tuple("Friday", Data_Date_Component.Friday.value), new Data_Tuple.Tuple("Saturday", Data_Date_Component.Saturday.value), new Data_Tuple.Tuple("Sunday", Data_Date_Component.Sunday.value) ]);
};
var parseDayOfWeekName1 = /* #__PURE__ */ parseDayOfWeekName(monadStateT);
var padSingleDigit = function (i) {
    if (i < 0) {
        return "-" + padSingleDigit(-i | 0);
    };
    if (i < 10) {
        return "0" + show(i);
    };
    if (Data_Boolean.otherwise) {
        return show(i);
    };
    throw new Error("Failed pattern match at Data.Formatter.DateTime (line 194, column 1 - line 194, column 32): " + [ i.constructor.name ]);
};
var padQuadrupleDigit = function (i) {
    if (i < 0) {
        return "-" + padQuadrupleDigit(-i | 0);
    };
    if (i < 10) {
        return "000" + show(i);
    };
    if (i < 100) {
        return "00" + show(i);
    };
    if (i < 1000) {
        return "0" + show(i);
    };
    if (Data_Boolean.otherwise) {
        return show(i);
    };
    throw new Error("Failed pattern match at Data.Formatter.DateTime (line 207, column 1 - line 207, column 35): " + [ i.constructor.name ]);
};
var padDoubleDigit = function (i) {
    if (i < 0) {
        return "-" + padDoubleDigit(-i | 0);
    };
    if (i < 10) {
        return "00" + show(i);
    };
    if (i < 100) {
        return "0" + show(i);
    };
    if (Data_Boolean.otherwise) {
        return show(i);
    };
    throw new Error("Failed pattern match at Data.Formatter.DateTime (line 200, column 1 - line 200, column 32): " + [ i.constructor.name ]);
};
var initialAccum = /* #__PURE__ */ (function () {
    return {
        year: Data_Maybe.Nothing.value,
        month: Data_Maybe.Nothing.value,
        day: Data_Maybe.Nothing.value,
        hour: Data_Maybe.Nothing.value,
        minute: Data_Maybe.Nothing.value,
        second: Data_Maybe.Nothing.value,
        millisecond: Data_Maybe.Nothing.value,
        meridiem: Data_Maybe.Nothing.value
    };
})();
var genericFormatter = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return YearFull.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return YearTwoDigits.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return YearAbsolute.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return MonthFull.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return MonthShort.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return MonthTwoDigits.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return DayOfMonthTwoDigits.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
            return DayOfMonth.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
            return UnixTimestamp.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))) {
            return DayOfWeek.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))) {
            return DayOfWeekName.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))) {
            return DayOfWeekNameShort.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))) {
            return Hours24.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))) {
            return Hours12.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))) {
            return Meridiem.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))) {
            return Minutes.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))) {
            return MinutesTwoDigits.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))))) {
            return Seconds.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))))) {
            return SecondsTwoDigits.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))))))) {
            return Milliseconds.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))))))) {
            return MillisecondsShort.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))))))))) {
            return MillisecondsTwoDigits.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))))))))))))))))))) {
            return new Placeholder(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Data.Formatter.DateTime (line 78, column 1 - line 78, column 63): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof YearFull) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof YearTwoDigits) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof YearAbsolute) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof MonthFull) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof MonthShort) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
        };
        if (x instanceof MonthTwoDigits) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
        };
        if (x instanceof DayOfMonthTwoDigits) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))));
        };
        if (x instanceof DayOfMonth) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))));
        };
        if (x instanceof UnixTimestamp) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))));
        };
        if (x instanceof DayOfWeek) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))));
        };
        if (x instanceof DayOfWeekName) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))));
        };
        if (x instanceof DayOfWeekNameShort) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))));
        };
        if (x instanceof Hours24) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))));
        };
        if (x instanceof Hours12) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))));
        };
        if (x instanceof Meridiem) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))));
        };
        if (x instanceof Minutes) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))))));
        };
        if (x instanceof MinutesTwoDigits) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))))));
        };
        if (x instanceof Seconds) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))))))));
        };
        if (x instanceof SecondsTwoDigits) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))))))));
        };
        if (x instanceof Milliseconds) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))))))))));
        };
        if (x instanceof MillisecondsShort) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))))))))));
        };
        if (x instanceof MillisecondsTwoDigits) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))))))))))));
        };
        if (x instanceof Placeholder) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))))))))))))))))))));
        };
        throw new Error("Failed pattern match at Data.Formatter.DateTime (line 78, column 1 - line 78, column 63): " + [ x.constructor.name ]);
    }
};
var showFormatter = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericFormatter)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "YearFull";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "YearTwoDigits";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "YearAbsolute";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "MonthFull";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "MonthShort";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "MonthTwoDigits";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "DayOfMonthTwoDigits";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "DayOfMonth";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "UnixTimestamp";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "DayOfWeek";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "DayOfWeekName";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "DayOfWeekNameShort";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Hours24";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Hours12";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Meridiem";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Minutes";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "MinutesTwoDigits";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Seconds";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "SecondsTwoDigits";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Milliseconds";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "MillisecondsShort";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "MillisecondsTwoDigits";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))({
        reflectSymbol: function () {
            return "Placeholder";
        }
    }))))))))))))))))))))))))
};
var formatterCommandParser = /* #__PURE__ */ (function () {
    return Control_Alt.alt(Parsing.altParserT)(oneOfAs(Data_Identity.monadIdentity)(function ($663) {
        return Parsing_Combinators["try"](Parsing_String.string($663));
    })([ new Data_Tuple.Tuple("YYYY", YearFull.value), new Data_Tuple.Tuple("YY", YearTwoDigits.value), new Data_Tuple.Tuple("Y", YearAbsolute.value), new Data_Tuple.Tuple("MMMM", MonthFull.value), new Data_Tuple.Tuple("MMM", MonthShort.value), new Data_Tuple.Tuple("MM", MonthTwoDigits.value), new Data_Tuple.Tuple("DD", DayOfMonthTwoDigits.value), new Data_Tuple.Tuple("D", DayOfMonth.value), new Data_Tuple.Tuple("E", DayOfWeek.value), new Data_Tuple.Tuple("X", UnixTimestamp.value), new Data_Tuple.Tuple("dddd", DayOfWeekName.value), new Data_Tuple.Tuple("ddd", DayOfWeekNameShort.value), new Data_Tuple.Tuple("HH", Hours24.value), new Data_Tuple.Tuple("hh", Hours12.value), new Data_Tuple.Tuple("a", Meridiem.value), new Data_Tuple.Tuple("mm", MinutesTwoDigits.value), new Data_Tuple.Tuple("m", Minutes.value), new Data_Tuple.Tuple("ss", SecondsTwoDigits.value), new Data_Tuple.Tuple("s", Seconds.value), new Data_Tuple.Tuple("SSS", Milliseconds.value), new Data_Tuple.Tuple("SS", MillisecondsTwoDigits.value), new Data_Tuple.Tuple("S", MillisecondsShort.value) ]))(map(Placeholder.create)(placeholderContent));
})();
var formatYearTwoDigits = function (i) {
    var dateString = show(abs(i));
    var dateLength = Data_String_CodePoints.length(dateString);
    if (dateLength === 1) {
        return "0" + dateString;
    };
    if (dateLength === 2) {
        return dateString;
    };
    return Data_String_CodePoints.drop(dateLength - 2 | 0)(dateString);
};
var formatParser = /* #__PURE__ */ some(formatterCommandParser);
var parseFormatString = /* #__PURE__ */ Data_Formatter_Parser_Utils.runP(formatParser);
var fix12 = function (h) {
    var $617 = h === 0;
    if ($617) {
        return 12;
    };
    return h;
};
var formatCommand = function (v) {
    return function (v1) {
        if (v1 instanceof YearFull) {
            return padQuadrupleDigit(fromEnum(Data_Date.year(v.value0)));
        };
        if (v1 instanceof YearTwoDigits) {
            return formatYearTwoDigits(fromEnum(Data_Date.year(v.value0)));
        };
        if (v1 instanceof YearAbsolute) {
            return show(fromEnum(Data_Date.year(v.value0)));
        };
        if (v1 instanceof MonthFull) {
            return show1(Data_Date.month(v.value0));
        };
        if (v1 instanceof MonthShort) {
            return printShortMonth(Data_Date.month(v.value0));
        };
        if (v1 instanceof MonthTwoDigits) {
            return padSingleDigit(fromEnum1(Data_Date.month(v.value0)));
        };
        if (v1 instanceof DayOfMonthTwoDigits) {
            return padSingleDigit(fromEnum2(Data_Date.day(v.value0)));
        };
        if (v1 instanceof DayOfMonth) {
            return show(fromEnum2(Data_Date.day(v.value0)));
        };
        if (v1 instanceof UnixTimestamp) {
            return show(Data_Int.floor((function (v2) {
                return v2 / 1000.0;
            })(unwrap(Data_DateTime_Instant.unInstant(Data_DateTime_Instant.fromDateTime(v))))));
        };
        if (v1 instanceof DayOfWeek) {
            return show(fromEnum3(Data_Date.weekday(v.value0)));
        };
        if (v1 instanceof DayOfWeekName) {
            return show2(Data_Date.weekday(v.value0));
        };
        if (v1 instanceof DayOfWeekNameShort) {
            return Data_String_CodePoints.take(3)(show2(Data_Date.weekday(v.value0)));
        };
        if (v1 instanceof Hours24) {
            return padSingleDigit(fromEnum4(Data_Time.hour(v.value1)));
        };
        if (v1 instanceof Hours12) {
            return padSingleDigit(fix12(mod(fromEnum4(Data_Time.hour(v.value1)))(12)));
        };
        if (v1 instanceof Meridiem) {
            var $620 = fromEnum4(Data_Time.hour(v.value1)) >= 12;
            if ($620) {
                return "PM";
            };
            return "AM";
        };
        if (v1 instanceof Minutes) {
            return show(fromEnum5(Data_Time.minute(v.value1)));
        };
        if (v1 instanceof MinutesTwoDigits) {
            return padSingleDigit(fromEnum5(Data_Time.minute(v.value1)));
        };
        if (v1 instanceof Seconds) {
            return show(fromEnum6(Data_Time.second(v.value1)));
        };
        if (v1 instanceof SecondsTwoDigits) {
            return padSingleDigit(fromEnum6(Data_Time.second(v.value1)));
        };
        if (v1 instanceof Milliseconds) {
            return padDoubleDigit(fromEnum7(Data_Time.millisecond(v.value1)));
        };
        if (v1 instanceof MillisecondsShort) {
            return show((function (v2) {
                return div1(v2)(100);
            })(fromEnum7(Data_Time.millisecond(v.value1))));
        };
        if (v1 instanceof MillisecondsTwoDigits) {
            return padSingleDigit((function (v2) {
                return div1(v2)(10);
            })(fromEnum7(Data_Time.millisecond(v.value1))));
        };
        if (v1 instanceof Placeholder) {
            return v1.value0;
        };
        throw new Error("Failed pattern match at Data.Formatter.DateTime (line 169, column 38 - line 192, column 21): " + [ v1.constructor.name ]);
    };
};
var format = function (f) {
    return function (d) {
        return foldMap1(formatCommand(d))(f);
    };
};
var formatDateTime = function (pattern) {
    return function (datetime) {
        return mapFlipped1(parseFormatString(pattern))(function (v) {
            return format(v)(datetime);
        });
    };
};
var exactLength = /* #__PURE__ */ bind(ask)(function (v) {
    return lift((function () {
        var $625 = v.maxLength !== v.length;
        if ($625) {
            return new Data_Either.Left("Expected " + (show(v.maxLength) + (" digits but got " + show(v.length))));
        };
        return new Data_Either.Right(Data_Unit.unit);
    })());
});
var unformatCommandParser = /* #__PURE__ */ (function () {
    var modifyWithParser = function (f) {
        return function (p) {
            return bind1(p)(function (v) {
                return lift1(modify_(Data_Function.flip(f)(new Data_Maybe.Just(v))));
            });
        };
    };
    return function (v) {
        if (v instanceof YearFull) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        year: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second
                    };
                };
            })(parseSignedInt1(4)(exactLength)("Incorrect full year"));
        };
        if (v instanceof YearTwoDigits) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        year: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second
                    };
                };
            })(parseSignedInt1(2)(exactLength)("Incorrect 2-digit year"));
        };
        if (v instanceof YearAbsolute) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        year: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second
                    };
                };
            })(lift2(mul)(Parsing_Combinators.option(1)(Parsing_Combinators["try"](mapFlipped(Parsing_String.string("-"))(Data_Function["const"](-1 | 0)))))(mapFlipped(some(parseDigit))(foldDigits)));
        };
        if (v instanceof MonthFull) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        month: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(map(fromEnum1)(parseMonth1));
        };
        if (v instanceof MonthShort) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        month: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(map(fromEnum1)(parseShortMonth1));
        };
        if (v instanceof MonthTwoDigits) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        month: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(parseInt1(2)(append1(validateRange(1)(12))(exactLength))("Incorrect 2-digit month"));
        };
        if (v instanceof DayOfMonthTwoDigits) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        day: v2,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(parseInt1(2)(append1(validateRange(1)(31))(exactLength))("Incorrect day of month"));
        };
        if (v instanceof DayOfMonth) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        day: v2,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(parseInt1(2)(validateRange(1)(31))("Incorrect day of month"));
        };
        if (v instanceof UnixTimestamp) {
            return bind1(map(foldDigits)(some(parseDigit)))(function (s) {
                var v1 = map1(Data_DateTime_Instant.toDateTime)(Data_DateTime_Instant.instant(1000.0 * Data_Int.toNumber(s)));
                if (v1 instanceof Data_Maybe.Nothing) {
                    return Parsing.fail("Incorrect timestamp");
                };
                if (v1 instanceof Data_Maybe.Just) {
                    return lift1(put({
                        year: new Data_Maybe.Just(fromEnum(Data_Date.year(v1.value0.value0))),
                        month: new Data_Maybe.Just(fromEnum1(Data_Date.month(v1.value0.value0))),
                        day: new Data_Maybe.Just(fromEnum2(Data_Date.day(v1.value0.value0))),
                        hour: new Data_Maybe.Just(fromEnum4(Data_Time.hour(v1.value0.value1))),
                        minute: new Data_Maybe.Just(fromEnum5(Data_Time.minute(v1.value0.value1))),
                        second: new Data_Maybe.Just(fromEnum6(Data_Time.second(v1.value0.value1))),
                        millisecond: new Data_Maybe.Just(fromEnum7(Data_Time.millisecond(v1.value0.value1))),
                        meridiem: Data_Maybe.Nothing.value
                    }));
                };
                throw new Error("Failed pattern match at Data.Formatter.DateTime (line 369, column 5 - line 380, column 10): " + [ v1.constructor.name ]);
            });
        };
        if (v instanceof DayOfWeek) {
            return $$void(parseInt1(1)(validateRange(1)(7))("Incorrect day of week"));
        };
        if (v instanceof DayOfWeekName) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        day: v2,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(map(fromEnum3)(parseDayOfWeekName1));
        };
        if (v instanceof DayOfWeekNameShort) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        day: v2,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(map(fromEnum3)(parseDayOfWeekNameShort1));
        };
        if (v instanceof Hours24) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        hour: v2,
                        day: v1.day,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(parseInt1(2)(append1(validateRange(0)(24))(exactLength))("Incorrect 24 hour"));
        };
        if (v instanceof Hours12) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        hour: v2,
                        day: v1.day,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(parseInt1(2)(append1(validateRange(0)(12))(exactLength))("Incorrect 12 hour"));
        };
        if (v instanceof Meridiem) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        meridiem: v2,
                        day: v1.day,
                        hour: v1.hour,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(parseMeridiem1);
        };
        if (v instanceof MinutesTwoDigits) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        minute: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(parseInt1(2)(append1(validateRange(0)(59))(exactLength))("Incorrect 2-digit minute"));
        };
        if (v instanceof Minutes) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        minute: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(parseInt1(2)(validateRange(0)(59))("Incorrect minute"));
        };
        if (v instanceof SecondsTwoDigits) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        second: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        year: v1.year
                    };
                };
            })(parseInt1(2)(append1(validateRange(0)(59))(exactLength))("Incorrect 2-digit second"));
        };
        if (v instanceof Seconds) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        second: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        year: v1.year
                    };
                };
            })(parseInt1(2)(validateRange(0)(59))("Incorrect second"));
        };
        if (v instanceof Milliseconds) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        millisecond: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(parseInt1(3)(exactLength)("Incorrect millisecond"));
        };
        if (v instanceof Placeholder) {
            return $$void(Parsing_String.string(v.value0));
        };
        if (v instanceof MillisecondsShort) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        millisecond: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(mapFlipped(parseInt1(1)(exactLength)("Incorrect 1-digit millisecond"))(function (v1) {
                return v1 * 100 | 0;
            }));
        };
        if (v instanceof MillisecondsTwoDigits) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        millisecond: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(mapFlipped(parseInt1(2)(exactLength)("Incorrect 2-digit millisecond"))(function (v1) {
                return v1 * 10 | 0;
            }));
        };
        throw new Error("Failed pattern match at Data.Formatter.DateTime (line 347, column 25 - line 406, column 74): " + [ v.constructor.name ]);
    };
})();
var eqMeridiem = {
    eq: function (x) {
        return function (y) {
            if (x instanceof AM && y instanceof AM) {
                return true;
            };
            if (x instanceof PM && y instanceof PM) {
                return true;
            };
            return false;
        };
    }
};
var eqFormatterCommand = {
    eq: function (x) {
        return function (y) {
            if (x instanceof YearFull && y instanceof YearFull) {
                return true;
            };
            if (x instanceof YearTwoDigits && y instanceof YearTwoDigits) {
                return true;
            };
            if (x instanceof YearAbsolute && y instanceof YearAbsolute) {
                return true;
            };
            if (x instanceof MonthFull && y instanceof MonthFull) {
                return true;
            };
            if (x instanceof MonthShort && y instanceof MonthShort) {
                return true;
            };
            if (x instanceof MonthTwoDigits && y instanceof MonthTwoDigits) {
                return true;
            };
            if (x instanceof DayOfMonthTwoDigits && y instanceof DayOfMonthTwoDigits) {
                return true;
            };
            if (x instanceof DayOfMonth && y instanceof DayOfMonth) {
                return true;
            };
            if (x instanceof UnixTimestamp && y instanceof UnixTimestamp) {
                return true;
            };
            if (x instanceof DayOfWeek && y instanceof DayOfWeek) {
                return true;
            };
            if (x instanceof DayOfWeekName && y instanceof DayOfWeekName) {
                return true;
            };
            if (x instanceof DayOfWeekNameShort && y instanceof DayOfWeekNameShort) {
                return true;
            };
            if (x instanceof Hours24 && y instanceof Hours24) {
                return true;
            };
            if (x instanceof Hours12 && y instanceof Hours12) {
                return true;
            };
            if (x instanceof Meridiem && y instanceof Meridiem) {
                return true;
            };
            if (x instanceof Minutes && y instanceof Minutes) {
                return true;
            };
            if (x instanceof MinutesTwoDigits && y instanceof MinutesTwoDigits) {
                return true;
            };
            if (x instanceof Seconds && y instanceof Seconds) {
                return true;
            };
            if (x instanceof SecondsTwoDigits && y instanceof SecondsTwoDigits) {
                return true;
            };
            if (x instanceof Milliseconds && y instanceof Milliseconds) {
                return true;
            };
            if (x instanceof MillisecondsShort && y instanceof MillisecondsShort) {
                return true;
            };
            if (x instanceof MillisecondsTwoDigits && y instanceof MillisecondsTwoDigits) {
                return true;
            };
            if (x instanceof Placeholder && y instanceof Placeholder) {
                return x.value0 === y.value0;
            };
            return false;
        };
    }
};
var ordFormatterCommand = {
    compare: function (x) {
        return function (y) {
            if (x instanceof YearFull && y instanceof YearFull) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof YearFull) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof YearFull) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof YearTwoDigits && y instanceof YearTwoDigits) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof YearTwoDigits) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof YearTwoDigits) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof YearAbsolute && y instanceof YearAbsolute) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof YearAbsolute) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof YearAbsolute) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof MonthFull && y instanceof MonthFull) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof MonthFull) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof MonthFull) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof MonthShort && y instanceof MonthShort) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof MonthShort) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof MonthShort) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof MonthTwoDigits && y instanceof MonthTwoDigits) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof MonthTwoDigits) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof MonthTwoDigits) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof DayOfMonthTwoDigits && y instanceof DayOfMonthTwoDigits) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof DayOfMonthTwoDigits) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof DayOfMonthTwoDigits) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof DayOfMonth && y instanceof DayOfMonth) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof DayOfMonth) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof DayOfMonth) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof UnixTimestamp && y instanceof UnixTimestamp) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof UnixTimestamp) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof UnixTimestamp) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof DayOfWeek && y instanceof DayOfWeek) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof DayOfWeek) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof DayOfWeek) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof DayOfWeekName && y instanceof DayOfWeekName) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof DayOfWeekName) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof DayOfWeekName) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof DayOfWeekNameShort && y instanceof DayOfWeekNameShort) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof DayOfWeekNameShort) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof DayOfWeekNameShort) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Hours24 && y instanceof Hours24) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Hours24) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Hours24) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Hours12 && y instanceof Hours12) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Hours12) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Hours12) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Meridiem && y instanceof Meridiem) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Meridiem) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Meridiem) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Minutes && y instanceof Minutes) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Minutes) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Minutes) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof MinutesTwoDigits && y instanceof MinutesTwoDigits) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof MinutesTwoDigits) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof MinutesTwoDigits) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Seconds && y instanceof Seconds) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Seconds) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Seconds) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof SecondsTwoDigits && y instanceof SecondsTwoDigits) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof SecondsTwoDigits) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof SecondsTwoDigits) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Milliseconds && y instanceof Milliseconds) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Milliseconds) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Milliseconds) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof MillisecondsShort && y instanceof MillisecondsShort) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof MillisecondsShort) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof MillisecondsShort) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof MillisecondsTwoDigits && y instanceof MillisecondsTwoDigits) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof MillisecondsTwoDigits) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof MillisecondsTwoDigits) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Placeholder && y instanceof Placeholder) {
                return compare(x.value0)(y.value0);
            };
            throw new Error("Failed pattern match at Data.Formatter.DateTime (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqFormatterCommand;
    }
};
var adjustMeridiem = function (v) {
    return function (v1) {
        if (v instanceof Data_Maybe.Just && (v.value0 instanceof AM && v1 === 12)) {
            return 0;
        };
        if (v instanceof Data_Maybe.Just && (v.value0 instanceof PM && v1 === 12)) {
            return 12;
        };
        if (v instanceof Data_Maybe.Just && v.value0 instanceof PM) {
            return v1 + 12 | 0;
        };
        if (v instanceof Data_Maybe.Just && v.value0 instanceof AM) {
            return v1;
        };
        if (v instanceof Data_Maybe.Nothing && v1 === 24) {
            return 0;
        };
        if (v instanceof Data_Maybe.Nothing) {
            return v1;
        };
        throw new Error("Failed pattern match at Data.Formatter.DateTime (line 279, column 1 - line 279, column 47): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var adjustDay = function (v) {
    return function (n) {
        if (v instanceof Data_Maybe.Just && v.value0 === 24) {
            return n + 1 | 0;
        };
        return n;
    };
};
var unformatAccumToDateTime = function (a) {
    return applySecond(validAccum(a))(apply(map2(Data_DateTime.DateTime.create)(apply(apply(map2(Data_Date.canonicalDate)(Data_Maybe.maybe(new Data_Either.Left("Incorrect year"))(pure)(toEnum(Data_Maybe.fromMaybe(0)(a.year)))))(Data_Maybe.maybe(new Data_Either.Left("Incorrect month"))(pure)(toEnum1(Data_Maybe.fromMaybe(1)(a.month)))))(Data_Maybe.maybe(new Data_Either.Left("Incorrect day"))(pure)(toEnum2(adjustDay(a.hour)(Data_Maybe.fromMaybe(1)(a.day)))))))(apply(apply(apply(map2(Data_Time.Time.create)(Data_Maybe.maybe(new Data_Either.Left("Incorrect hour"))(pure)(toEnum3(Data_Maybe.fromMaybe(0)(map1(adjustMeridiem(a.meridiem))(a.hour))))))(Data_Maybe.maybe(new Data_Either.Left("Incorrect minute"))(pure)(toEnum4(Data_Maybe.fromMaybe(0)(a.minute)))))(Data_Maybe.maybe(new Data_Either.Left("Incorrect second"))(pure)(toEnum5(Data_Maybe.fromMaybe(0)(a.second)))))(Data_Maybe.maybe(new Data_Either.Left("Incorrect millisecond"))(pure)(toEnum6(Data_Maybe.fromMaybe(0)(a.millisecond))))));
};
var unformatParser = function (dictMonad) {
    var mapParserT1 = mapParserT(((dictMonad.Bind1()).Apply0()).Functor0());
    return function (f) {
        var unState = function (dictMonad1) {
            var pure2 = Control_Applicative.pure(dictMonad1.Applicative0());
            return function (s) {
                var v = Control_Monad_State.runState(s)(initialAccum);
                return pure2(new Data_Tuple.Tuple(voidLeft(v.value0.value0)(v.value1), v.value0.value1));
            };
        };
        return bind1(mapParserT1(unState(dictMonad))(foldMap2(unformatCommandParser)(f)))(function (acc) {
            return Data_Either.either(Parsing.fail)(pure1)(unformatAccumToDateTime(acc));
        });
    };
};
var unformat = /* #__PURE__ */ (function () {
    var $664 = unformatParser(Data_Identity.monadIdentity);
    return function ($665) {
        return Data_Formatter_Parser_Utils.runP($664($665));
    };
})();
var unformatDateTime = function (pattern) {
    return function (str) {
        return bind2(parseFormatString(pattern))(function (v) {
            return unformat(v)(str);
        });
    };
};
export {
    YearFull,
    YearTwoDigits,
    YearAbsolute,
    MonthFull,
    MonthShort,
    MonthTwoDigits,
    DayOfMonthTwoDigits,
    DayOfMonth,
    UnixTimestamp,
    DayOfWeek,
    DayOfWeekName,
    DayOfWeekNameShort,
    Hours24,
    Hours12,
    Meridiem,
    Minutes,
    MinutesTwoDigits,
    Seconds,
    SecondsTwoDigits,
    Milliseconds,
    MillisecondsShort,
    MillisecondsTwoDigits,
    Placeholder,
    printFormatter,
    printFormatterCommand,
    parseFormatString,
    format,
    formatDateTime,
    unformat,
    unformatDateTime,
    unformatParser,
    eqFormatterCommand,
    ordFormatterCommand,
    genericFormatter,
    showFormatter,
    eqMeridiem
};
